<div class="d-flex justify-content-between mt-4">
    <div>
        <searcher [label]="'Buscar Empleado'" (onChange)="search($event)" [showLoading]="showLoading"></searcher>
    </div>
    <div>
        <button (click)="openModal()" class="create-button">
            Crear Empleado
        </button>
    </div>
</div>
<app-table [data]="employees" [displayedColumns]="columns" [columnsNames]="columnsNames" [total]="total" [offset]="offset" [limit]="limit" (update)="update($event)"
    (delete)="delete($event)" (onPageChange)="handlePageChange($event)"></app-table>